import { AlertEventsReferenceData, AlertEventsSearchFiltersState } from "@idw-types/state/alert-events-state";
import { FormattedAlertEventHistory } from "@idw-types/data/alert-event-history";

export enum AlertEventsActionTypes {
    SET_ALERT_EVENTS_REFERENCE_DATA_LOADING = "SET_ALERT_EVENTS_REFERENCE_DATA_LOADING",
    SET_ALERT_EVENTS_REFERENCE_DATA = "SET_ALERT_EVENTS_REFERENCE_DATA",
    SET_ALERT_EVENTS_SEARCH_FILTERS = "SET_ALERT_EVENTS_SEARCH_FILTERS",
    SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING = "SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING",
    SET_ALERT_EVENTS_SEARCH_RESULTS = "SET_ALERT_EVENTS_SEARCH_RESULTS"
}

type SetAlertEventsReferenceDataLoadingAction = {
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_REFERENCE_DATA_LOADING;
    payload: { isLoading: boolean }
};

export const setAlertEventsReferenceDataLoading = (isLoading: boolean): SetAlertEventsReferenceDataLoadingAction => ({
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetAlertEventsReferenceDataAction = {
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_REFERENCE_DATA;
    payload: { referenceData: AlertEventsReferenceData };
};

export const setAlertEventsReferenceData = (referenceData: AlertEventsReferenceData): SetAlertEventsReferenceDataAction => ({
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_REFERENCE_DATA,
    payload: { referenceData }
});

type SetAlertEventsSearchFiltersAction = {
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_FILTERS;
    payload: { searchFilters: AlertEventsSearchFiltersState };
};

export const setAlertEventsSearchFilters = (searchFilters: AlertEventsSearchFiltersState): SetAlertEventsSearchFiltersAction => ({
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetAlertEventsSearchResultsLoadingAction = {
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setAlertEventsSearchResultsLoading = (isLoading: boolean): SetAlertEventsSearchResultsLoadingAction => ({
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetAlertEventsSearchResultsAction = {
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS;
    payload: { alertEvents: Array<FormattedAlertEventHistory> };
};

export const setAlertEventsSearchResults = (alertEvents: Array<FormattedAlertEventHistory>): SetAlertEventsSearchResultsAction => ({
    type: AlertEventsActionTypes.SET_ALERT_EVENTS_SEARCH_RESULTS,
    payload: { alertEvents }
});

export type AlertEventsActions =
    SetAlertEventsReferenceDataLoadingAction |
    SetAlertEventsReferenceDataAction |
    SetAlertEventsSearchFiltersAction |
    SetAlertEventsSearchResultsLoadingAction |
    SetAlertEventsSearchResultsAction